import React, { FunctionComponent, useCallback } from 'react';
import { MeetingsShortcutsRowProps } from './types';
import { userSelectors } from '../../../../../../app/resource/user/user.selectors';
import { useSelectWithParams } from '../../../../../../utils/selector.utils';
import { CircularAvatar } from '../../../../common/CustomAvatar';
import { useDispatch } from 'react-redux';
import { closeDialog, openDialog } from '../../../../../../app/dialog/dialog.actions';
import { meetingShortcutDelete } from '../../../../../../app/page/meeting-dashboard/meeting-dashboard.actions';
/* import { useDispatch } from 'react-redux';
import { openDialog } from '../../../../../../app/dialog/dialog.actions';
import { ITeamFileDeleteFileFormFormProps } from '../../../../common/forms/MeetingShortcutDeleteFileForm/types'; */

export const MeetingsShortcutsRow: FunctionComponent<MeetingsShortcutsRowProps> = ({ shortcut, meetingId }) => {
  /*   const dispatch = useDispatch();

  const openDeleteFileFormDialog = useCallback(() => {
    dispatch(openDialog('meetingShortcutDeleteFileDialog', { folderFileId: file.id } as ITeamFileDeleteFileFormFormProps));
  }, [dispatch, file.id]); */

  const user = useSelectWithParams(userSelectors.selectResourceById, shortcut.changedBy ?? '');

  const dispatch = useDispatch();

  const openUpdateFileFormDialog = useCallback(() => {
    dispatch(openDialog('meetingShortcutAddFileDialog', { shortcut }));
  }, [dispatch, shortcut]);

  const onDelete = useCallback(() => {
    dispatch(
      openDialog('deleteDialog', {
        onConfirm: () => {
          dispatch(closeDialog('deleteDialog'));
          dispatch(meetingShortcutDelete(shortcut.id, meetingId));
        },
        title: 'Delete shortcut',
        message: 'Are you sure you want to delete this shortcut?',
      }),
    );
  }, [dispatch, shortcut.id, meetingId]);

  return (
    <>
      <div className="flex-table" role="rowgroup">
        <div className="flex-row" role="cell">
          <div className="account-item">
            <div className="gray-box-pass blueGray-bg mr-1">{shortcut.extension}</div>
            <div className="account-item-desc">
              <h3 className="account-item-title">{shortcut.filename}</h3>
              <small className="blueGray">{shortcut.url}</small>
            </div>
          </div>
        </div>
        <div className="flex-row" role="cell">
          {user && (
            <CircularAvatar
              src={user.image}
              title={`${user.firstName} ${user.lastName}`}
              size="30"
              classes="bold"
              textSizeRatio={2.5}
              styles={{ margin: '10px 20px' }}
            />
          )}
        </div>
        <div className="flex-row wide" role="cell">
          <span className="blueGray">{shortcut.description || ''}</span>
        </div>
        <div className="flex-row aic jcr" role="cell">
          {/*<button className="round-icon-small mr-1">
            <img src="images/gdrive-icon.png" alt="" className="img-fluid" />
          </button>
          <button className="round-icon-small mr-1">
            <i className="icon2-folder"></i>
          </button>
          <butoon className="round-icon-small mr-1 popup_button" data-popup="new_password_popup">
            <i className="icon-pencil"></i>
          </butoon>{' '}
           */}
          <button className="round-icon-small mr-1" title="edit shortcut" onClick={openUpdateFileFormDialog}>
            <i className="icon-pencil" />
          </button>
          <button className="round-icon-small mr-1" title="delete shortcut" onClick={onDelete}>
            <i className="icon2-trash" />
          </button>
          <a
            href={shortcut.url}
            className="btn btn-md darkGray-bg mr-1"
            title="Start Meeting"
            target="_blank"
            rel="noopener noreferrer"
          >
            Visit Shortcut
          </a>
          {/*  <button
            className="round-icon-small mr-0 popup_button"
            data-popup="delete_popup"
            onClick={openDeleteFileFormDialog}
          >
            <i className="icon2-trash"></i>
          </button> */}
        </div>
      </div>
    </>
  );
};
